export default __webpack_public_path__ + "static/CircularStd-BookItalic-bc686b021b3fda56b8a1d08333a92bad.ttf";